import { format } from 'date-fns'

export default {
    orders: [],
    ordersLoading: false,
    cooperantDeliveryStatusNames: null,
    productsList: [],
    commentsList: [],
    setInitialFilters: setInitialFilters,
    filters: setInitialFilters()
}

function setInitialFilters() {
    return {
        status_id: '10', //Nowe
        plannedSendDate__gte: format(new Date(), 'YYYY-MM-DD'),
        plannedSendDate__lte: format(new Date(), 'YYYY-MM-DD'),
        showWithCooperantNumber: false,
        search: null
    }
}